import { Directive, HostBinding, Input } from '@angular/core';

import { ViewCacheOperationName } from './view-cache-operation-name.enum';
import { viewCacheOperationAttributeName, viewCacheOperationParametersAttributeName } from './view-cache-operation.constants';

/**
 * This Directive is responsible for placing `data-view-cache-operation` and
 * `data-view-cache-parameters` on the respective node.
 * When the ViewCache Snapshot is being taken, these attributes will be preserved,
 * and can be accessed by the ViewCacheOperations at that time.
 */
@Directive({
    selector: '[ohpViewCacheOperation]'
})
export class ViewCacheOperationDirective {
    @HostBinding(`attr.${viewCacheOperationAttributeName}`)
    @Input('ohpViewCacheOperation') public viewCacheOperation: ViewCacheOperationName;

    @HostBinding(`attr.${viewCacheOperationParametersAttributeName}`)
    @Input('ohpViewCacheParameters') public viewCacheParameters: string;
}